import { useGetPublicPendudukStatistikAgama } from '@tatatemplate/shared-lib'

export function useAgamaStats() {
  return useGetPublicPendudukStatistikAgama({
    query: { queryKey: ['statistik', 'agama'], staleTime: 5 * 60 * 1000, retry: 3 },
  })
}
